// получаем список вступительных роликов

export default async (context) => {
    await context.$axios.get('/entry')
        .then(({ data }) => {

            context.videos = data

            if(data.length > 0) {

                context.overlay = false
                context.error.status = false
                context.error.text = ''

                let videos = []

                data.forEach((item) => {
                    if(item.duration && (item.video || item.webm)) {
                        videos.push({
                            key: `f${(~~(Math.random()*1e8)).toString(16)}`,
                            status: false,
                            control: 'entry',
                            type: 'video',
                            ...item
                        })
                    }
                })

                if(videos.length) {
                    context.videos = [...videos]

                    context.$nextTick(() => {
                        context.rendering = true
                    })

                } else {
                    context.error.text = 'Список вступительных роликов для этой темы пуст. Пожалуйста, выберети другую тему'
                    context.overlay = true
                    context.error.status = true
                }

            } else {
                context.error.text = 'Список вступительных роликов для этой темы пуст. Пожалуйста, выберети другую тему'
                context.overlay = true
                context.error.status = true
            }

        })
        .catch(e => {
            console.error(e)
            context.error.text = 'Ошибка сервера! Не удалось получить список видео. Повторите попытку позже.'
            context.overlay = true
            context.error.status = true
        })
}